import React, { useState } from "react";
import { HiShare } from "react-icons/hi2";
import Image from "next/image";
import { parseCMSData, imageUrlFormatter } from "@/utils/cmsParser";
import SociaShare from "@/components/SocialShare";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

const Modal = props => {
  const { setOpen = false, modalData = {} } = props;
  const [show, setShow] = useState(false);
  const { locale } = useRouter();
  const { fields } = modalData || {};
  const pageData = parseCMSData(fields);
  const { name = "", imageUrl = "", alt = "" } = pageData || {};

  const description = renderRichText(fields?.description, locale);

  return (
    <div
      className="fixed inset-0 z-210 flex items-start justify-center bg-black/50 overflow-y-auto py-10"
      onClick={() => setOpen(false)}
    >
      <div
        className="bg-white w-full max-w-md shadow-lg px-6 relative pt-15 max-[1600px]:pt-[40px] pb-7"
        onClick={e => {
          e.stopPropagation();
          show && setShow(false);
        }}
      >
        <button
          onClick={() => setOpen(false)}
          className="absolute top-12 max-[1600px]:top-8 max-[1600px]:right-6 right-10 text-2xl text-[#232323] cursor-pointer"
        >
          ×
        </button>

        {name ? <h2 className="text-center koh-modal-title">{name}</h2> : null}
        <div
          class="koh-modal-color-palette-detail-container"
          data-webtest-id="koh-colour-description"
        >
          <div class="koh-modal-photo-wrapper w-full mt-10 mb-5 px-5">
            <Image
              width={100}
              height={100}
              src={imageUrl}
              id="modalImage"
              alt={alt}
              className="w-full h-auto block object-cover"
            />
          </div>

          <div class="modal-details mb-5 px-5 text-[#232323] text-[13px]">
            {description ? <p id="modalDescription">{description}</p> : null}
          </div>
        </div>

        <div class="koh-print-share-tools px-5 mb-5 mt-9">
          <div class="koh-page-share relative">
            {show && (
              <div className="absolute share-tooltip">
                <SociaShare />
              </div>
            )}
            <button
              onClick={() => setShow(!show)}
              className="koh-page-share-button flex items-center justify-items-center relative cursor-pointer "
              data-hasqtip="0"
              aria-describedby="qtip-0"
            >
              <HiShare />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
